import { render, staticRenderFns } from "./LkHeader.vue?vue&type=template&id=3396ddde&"
import script from "./LkHeader.vue?vue&type=script&lang=js&"
export * from "./LkHeader.vue?vue&type=script&lang=js&"
import style0 from "./LkHeader.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/lk/header/LkHeader.vue
// module id = 1581
// module chunks = 0